import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for common modal component customisation
 * Returns modal styling for container, icons, text, and buttons
 */
export const useModalCustomisation = () => {
  // Container background customisation
  const containerFields = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.MODAL,
    sectionKey: PUI.MODAL_SECTION_KEYS.CONTAINER_BACKGROUND,
    blockKey: PUI.MODAL_BLOCK_KEYS.MODAL_CONTAINER,
  });

  // Header customisation
  const headerIconFields = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.MODAL,
    sectionKey: PUI.MODAL_SECTION_KEYS.HEADER_ICON,
    blockKey: PUI.MODAL_BLOCK_KEYS.MODAL_HEADER,
  });

  const headerTextFields = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.MODAL,
    sectionKey: PUI.MODAL_SECTION_KEYS.HEADER_TEXT,
    blockKey: PUI.MODAL_BLOCK_KEYS.MODAL_HEADER,
  });

  // Content customisation
  const contentFields = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.MODAL,
    sectionKey: PUI.MODAL_SECTION_KEYS.MESSAGE_TEXT,
    blockKey: PUI.MODAL_BLOCK_KEYS.MODAL_CONTENT,
  });

  // Button customisation
  const primaryButtonFields = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.MODAL,
    sectionKey: PUI.MODAL_SECTION_KEYS.PRIMARY_BUTTON,
    blockKey: PUI.MODAL_BLOCK_KEYS.MODAL_BUTTONS,
  });

  const secondaryButtonFields = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.MODAL,
    sectionKey: PUI.MODAL_SECTION_KEYS.SECONDARY_BUTTON,
    blockKey: PUI.MODAL_BLOCK_KEYS.MODAL_BUTTONS,
  });

  const textButtonFields = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.MODAL,
    sectionKey: PUI.MODAL_SECTION_KEYS.TEXT_BUTTON,
    blockKey: PUI.MODAL_BLOCK_KEYS.MODAL_BUTTONS,
  });

  return {
    container: {
      backgroundColor: containerFields.getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR),
      borderColor: containerFields.getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR),
      isVisible: containerFields.isVisible,
    },
    header: {
      icon: {
        color: headerIconFields.getField(PUI.COMMON_FIELD_KEYS.ICON),
        isVisible: headerIconFields.isVisible,
      },
      text: {
        color: headerTextFields.getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR),
        isVisible: headerTextFields.isVisible,
      },
    },
    content: {
      textColor: contentFields.getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR),
      isVisible: contentFields.isVisible,
    },
    buttons: {
      primary: {
        backgroundColor: primaryButtonFields.getField(PUI.COMMON_FIELD_KEYS.BUTTON_BACKGROUND_COLOR),
        textColor: primaryButtonFields.getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT_COLOR),
        borderColor: primaryButtonFields.getField(PUI.COMMON_FIELD_KEYS.BUTTON_BORDER_COLOR),
        isVisible: primaryButtonFields.isVisible,
      },
      secondary: {
        backgroundColor: secondaryButtonFields.getField(PUI.COMMON_FIELD_KEYS.BUTTON_BACKGROUND_COLOR),
        textColor: secondaryButtonFields.getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT_COLOR),
        borderColor: secondaryButtonFields.getField(PUI.COMMON_FIELD_KEYS.BUTTON_BORDER_COLOR),
        isVisible: secondaryButtonFields.isVisible,
      },
      text: {
        textColor: textButtonFields.getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT_COLOR),
        isVisible: textButtonFields.isVisible,
      },
    },
  };
};
